import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { campaignAction } from "../../store/campaign-store";
import ReactTooltip from "react-tooltip";
import { BsInfoSquareFill } from "react-icons/bs";
import { BiRefresh } from "react-icons/bi";

import Select from "react-select";

import ColorPicker from "../UI/ColorPicker";

const LeftContentEditor = (props) => {
  const [editContent, setEdiContent] = useState([]);
  const [textLength, setTextLength] = useState([]);
  const [dummySingleslide, setDummySingleslide] = useState([]);
  const [dummySlideData, setDummySlideData] = useState([]);

  const { show, toggleLeftContentshow, layers_name, length } = props;
  const single_slide_data = useSelector(
    (state) => state.campaign.single_slide_data
  );
  const active_slide_name = useSelector(
    (state) => state.campaign.active_slide_name
  );

  const [popup_hv_class, setPopup_hv_class] = useState("");

  const get_lastcharacter = (datastring) => {
    let lastcharacter = datastring.slice(-1);
    return lastcharacter;
  };

  useEffect(() => {
    if (active_slide_name && (active_slide_name.includes("pq_slide_") || active_slide_name.includes("va_slide_") ) && (get_lastcharacter(active_slide_name) === 'v') ){
      setPopup_hv_class("popup_hv_vertical");
    }else if(active_slide_name && (active_slide_name.includes("pq_slide_") || active_slide_name.includes("va_slide_") ) && active_slide_name.includes("w")){
      setPopup_hv_class('popup_hv_wide');
    }else{
      setPopup_hv_class("");
    }
  }, [active_slide_name]);

  /*
    Rebuild or re-init React-tooltip 
  */
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const editSlideData = useSelector((state) => state.campaign.editSlideData);
  const options = [
    { value: "Poppins", label: "Poppins" },
    { value: "Poppins-ExtraBold", label: "Poppins Extra Bold" },
    { value: "Poppins-ExtraLight", label: "Poppins Extra Light" },
    { value: "Poppins-Thin", label: "Poppins Thin" },
    { value: "Poppins-Italic", label: "Poppins Italic" },
    { value: "Poppins-Medium", label: "Poppins Medium" },
    { value: "Poppins-Bold", label: "Poppins Bold" },

    { value: "Poppins-SemiBold", label: "Poppins Semi Bold" },
    { value: "Poppins-SemiBoldItalic", label: "Poppins Semi Bold Italic" },

    { value: "Roboto", label: "Roboto" },
    { value: "Roboto-Bold", label: "Roboto Bold" },
    { value: "Roboto-BoldItalic", label: "Roboto Bold Italic" },
    { value: "Roboto-Italic", label: "Roboto Italic" },
    { value: "Roboto-Medium", label: "Roboto Medium" },
    { value: "Roboto-Black", label: "Roboto Black" },

    { value: "Ubuntu", label: "Ubuntu" },
    { value: "Ubuntu-Bold", label: "Ubuntu Bold" },

    { value: "Ubuntu-Medium", label: "Ubuntu Medium" },
    { value: "Ubuntu-Italic", label: "Ubuntu Italic" },
    { value: "BebasNeueBold", label: "Bebas Neue Bold" },
    { value: "BebasNeueBook", label: "Bebas Neue Book" },
    { value: "BebasNeueRegular", label: "Bebas Neue Regular" },

    { value: "Montserrat", label: "Montserrat" },
    { value: "Montserrat-Italic", label: "Montserrat Italic" },
    { value: "Montserrat-Medium", label: "Montserrat Medium" },

    { value: "Montserrat-SemiBold", label: "Montserrat SemiBold" },
    { value: "Montserrat-SemiBoldItalic", label: "Montserrat SemiBold Italic" },

    { value: "Montserrat-Thin", label: "Montserrat Thin" },
    { value: "Montserrat-Bold", label: "Montserrat Bold" },
    { value: "Montserrat-ExtraBold", label: "Montserrat ExtraBold" },
    { value: "Montserrat-BoldItalic", label: "Montserrat Bold Italic" },
    // { value: "Nexa", label: "Nexa" },
    { value: "NexaBold", label: "Nexa Bold" },
    // { value: "Nexa-Light", label: "Nexa Light" },
    { value: "Lobster", label: "Lobster" },
    { value: "Play Fair", label: "Play Fair" },

    { value: "Play Fair-ExtraBold", label: "Play Fair ExtraBold" },
    { value: "Play Fair-Medium", label: "Play Fair Medium" },
    { value: "Play Fair-SemiBold", label: "Play Fair SemiBold" },
    { value: "Amanda Signature", label: "Amanda Signature" },
    { value: "Tw Cen MT", label: "Tw Cen MT" },
    { value: "Berkshire Swash", label: "Berkshire Swash" },
    { value: "AlegreSansRegular", label: "Alegre Sans Regular" },
    { value: "Tenor Sans", label: "Tenor Sans" },
    { value: "Gilroy-Medium", label: "Gilroy Medium" },
    { value: "Gilroy-Bold", label: "Gilroy Bold" },
    { value: "Gilroy-ExtraBold", label: "Gilroy ExtraBold" },
    { value: "DIN Condensed", label: "DIN Condensed Bold" },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    if (show) {
      // console.log(single_slide_data);

      let split_layer = layers_name.split("||");
      let single_slide_clone = [...single_slide_data.assets];
      // console.log(split_layer);

      // console.log(single_slide_clone);
      var new_data = single_slide_clone.filter(
        (assets) => split_layer.includes(assets.layerName) === true
      );
      // console.log(new_data);
      setEdiContent(new_data);

      setTextLength(length.split("||"));
      setDummySingleslide(single_slide_data);
      setDummySlideData(editSlideData);
      // console.log(editSlideData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log(dummySlideData);

    // return false;
    if (dummySlideData) {
      dispatch(campaignAction.setSlideData({ data: dummySlideData }));
    }

    if (dummySingleslide) {
      dispatch(campaignAction.setSingleSlideData({ data: dummySingleslide }));
      dispatch(campaignAction.appendVideoData());
    }
    e.preventDefault();
    toggleLeftContentshow();
  };

  const handleChnage = async (e, layer_name, index) => {
    // console.log(editContent);
    // console.log(layer_name, index);
    e.preventDefault();
    var single_layer = { ...editContent[index] };
    single_layer.text = e.target.value;
    // console.log(e.target.value);

    var newEditContent = [...editContent];
    newEditContent[index] = single_layer;

    setNewEditslideData(layer_name, e.target.value);
    setEdiContent(newEditContent);

    var copy_slide = { ...dummySingleslide };
    var assets = copy_slide.assets;
    var newData = assets.map((slide_data) => {
      var a = { ...slide_data };
      // console.log(a);
      if (a.layerName === layer_name) {
        a = { ...a, ...single_layer };
      }
      return a;
    });
    copy_slide.assets = newData;

    setDummySingleslide(copy_slide);
    // state.single_slide_data = copy_slide;

    // console.log(copy_slide);
  };

  const handleHRXColor = (layer_name, index, color) => {
    var single_layer = { ...editContent[index] };
    single_layer.text = color;

    var newEditContent = [...editContent];
    newEditContent[index] = single_layer;

    setNewEditslideData(layer_name, color);
    setEdiContent(newEditContent);

    var copy_slide = { ...dummySingleslide };
    var assets = copy_slide.assets;
    var newData = assets.map((slide_data) => {
      var a = { ...slide_data };
      // console.log(a);
      if (a.layerName === layer_name) {
        a = { ...a, ...single_layer };
      }
      return a;
    });
    copy_slide.assets = newData;

    setDummySingleslide(copy_slide);
  };

  const handleColor = (layer_name, index, color) => {
    // console.log(layer_name, index, color);
    var single_layer = { ...editContent[index] };
    single_layer.fontColor = color;

    var newEditContent = [...editContent];
    newEditContent[index] = single_layer;

    setEdiContent(newEditContent);

    var copy_slide = { ...dummySingleslide };
    var assets = copy_slide.assets;
    var newData = assets.map((slide_data) => {
      var a = { ...slide_data };
      // console.log(a);
      if (a.layerName === layer_name) {
        a = { ...a, ...single_layer };
      }
      return a;
    });
    copy_slide.assets = newData;
    setDummySingleslide(copy_slide);

    // state.single_slide_data = copy_slide;
    // dispatch(campaignAction.setSingleSlideData({ data: copy_slide }));
    // dispatch(campaignAction.appendVideoData());
  };

  // const handleChnageFont = (e, layer_name, index) => {
  //   var single_layer = { ...editContent[index] };
  //   single_layer.fontSize = e.target.value;

  //   var newEditContent = [...editContent];
  //   newEditContent[index] = single_layer;

  //   setEdiContent(newEditContent);

  //   var copy_slide = { ...dummySingleslide };
  //   var assets = copy_slide.assets;
  //   var newData = assets.map((slide_data) => {
  //     var a = { ...slide_data };
  //     // console.log(a);
  //     if (a.layerName === layer_name) {
  //       a = { ...a, ...single_layer };
  //     }
  //     return a;
  //   });
  //   copy_slide.assets = newData;
  //   // state.single_slide_data = copy_slide;
  //   setDummySingleslide(copy_slide);

  //   // dispatch(campaignAction.setSingleSlideData({ data: copy_slide }));
  //   // dispatch(campaignAction.appendVideoData());
  // };

  const handleChangeFontFamily = (e, layer_name, index) => {
    // console.log(e.value);
    var single_layer = { ...editContent[index] };
    single_layer.fontFamily = e.value;

    var newEditContent = [...editContent];
    newEditContent[index] = single_layer;

    setEdiContent(newEditContent);

    var copy_slide = { ...dummySingleslide };
    var assets = copy_slide.assets;
    var newData = assets.map((slide_data) => {
      var a = { ...slide_data };
      // console.log(a);
      if (a.layerName === layer_name) {
        a = { ...a, ...single_layer };
      }
      return a;
    });
    copy_slide.assets = newData;
    setDummySingleslide(copy_slide);

    // state.single_slide_data = copy_slide;
    // dispatch(campaignAction.setSingleSlideData({ data: copy_slide }));
    // dispatch(campaignAction.appendVideoData());
  };

  const setNewEditslideData = (layer_name, text) => {
    console.log(layer_name);
    var new_edit_slide_data = { ...dummySlideData };

    if (layer_name === "hello") {
      new_edit_slide_data.hello = text;
    }

    if (layer_name === "bg_color") {
      new_edit_slide_data.bg_color = text;
    }

    if (layer_name === "bg_color_1") {
      new_edit_slide_data.bg_color_1 = text;
    }

    if (layer_name === "bg_color_stroke") {
      new_edit_slide_data.bg_color_stroke = text;
    }

    if (layer_name === "hey") {
      new_edit_slide_data.hey = text;
    }

    if (layer_name === "home A") {
      new_edit_slide_data.home_a = text;
    }

    if (layer_name === "home B") {
      new_edit_slide_data.home_b = text;
    }

    if (layer_name === "home C") {
      new_edit_slide_data.home_c = text;
    }

    if (layer_name === "number") {
      new_edit_slide_data.number = text;
    }

    if (layer_name === "problem A") {
      new_edit_slide_data.problem_a = text;
    }

    if (layer_name === "problem B") {
      new_edit_slide_data.problem_b = text;
    }

    if (layer_name === "problem C") {
      new_edit_slide_data.problem_c = text;
    }

    if (layer_name === "problem D") {
      new_edit_slide_data.problem_d = text;
    }

    if (layer_name === "trust A") {
      new_edit_slide_data.trust_a = text;
    }

    if (layer_name === "trust B") {
      new_edit_slide_data.trust_b = text;
    }

    if (layer_name === "trust C") {
      new_edit_slide_data.trust_c = text;
    }

    if (layer_name === "resolve A") new_edit_slide_data.resolve_a = text;
    if (layer_name === "resolve B") new_edit_slide_data.resolve_b = text;
    if (layer_name === "resolve E") new_edit_slide_data.resolve_e = text;
    if (layer_name === "resolve F") new_edit_slide_data.resolve_f = text;

    if (layer_name === "resolve C")
      new_edit_slide_data.resolve_c = text.replace("  ", "<br />");

    if (layer_name === "resolve D")
      new_edit_slide_data.resolve_d = text.replace("  ", "<br />");

    if (layer_name === "solution A" || layer_name === "solutions A")
      new_edit_slide_data.solution_a = text;
    if (layer_name === "solution B" || layer_name === "solutions B")
      new_edit_slide_data.solution_b = text;
    if (layer_name === "solution C" || layer_name === "solutions C")
      new_edit_slide_data.solution_c = text;
    if (layer_name === "solution D") new_edit_slide_data.solution_d = text;

    if (layer_name === "contact A") new_edit_slide_data.contact_a = text;
    if (layer_name === "contact B") new_edit_slide_data.contact_b = text;
    if (
      layer_name === "website" ||
      layer_name === "web_url" ||
      layer_name === "website_url"
    )
      new_edit_slide_data.website = text;
    if (layer_name === "bg_image") {
      new_edit_slide_data.bg_image = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image = new_edit_slide_data.default_src;
    }

    if (layer_name === "bg_image_1") {
      new_edit_slide_data.bg_image_1 = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image_1 = new_edit_slide_data.default_src;
    }

    if (layer_name === "bg_image_2") {
      new_edit_slide_data.bg_image_2 = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image_2 = new_edit_slide_data.default_src;
    }

    if (layer_name === "bg_image_3") {
      new_edit_slide_data.bg_image_3 = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image_3 = new_edit_slide_data.default_src;
    }

    if (layer_name === "bg_image1") {
      new_edit_slide_data.bg_image1 = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image1 = new_edit_slide_data.default_src;
    }

    if (layer_name === "bg_image2") {
      new_edit_slide_data.bg_image2 = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image2 = new_edit_slide_data.default_src;
    }

    if (layer_name === "bg_image3") {
      new_edit_slide_data.bg_image3 = new_edit_slide_data.src;
      new_edit_slide_data.default_bg_image3 = new_edit_slide_data.default_src;
    }

    if (layer_name === "logo")
      new_edit_slide_data.logo = new_edit_slide_data.src;
    new_edit_slide_data.default_logo = new_edit_slide_data.default_src;

    if (layer_name === "pamper A") new_edit_slide_data.pamper_a = text;
    if (layer_name === "pamper B") new_edit_slide_data.pamper_b = text;
    if (layer_name === "pamper C") new_edit_slide_data.pamper_c = text;
    if (layer_name === "pamper D") new_edit_slide_data.pamper_d = text;

    if (layer_name === "service A") new_edit_slide_data.service_a = text;
    if (layer_name === "service B") new_edit_slide_data.service_b = text;
    if (layer_name === "service C") new_edit_slide_data.service_c = text;

    if (layer_name === "plan A") new_edit_slide_data.plan_a = text;
    if (layer_name === "plan B") new_edit_slide_data.plan_b = text;

    if (layer_name === "customer A") new_edit_slide_data.customer_a = text;
    if (layer_name === "customer B") new_edit_slide_data.customer_b = text;
    if (layer_name === "customer C") new_edit_slide_data.customer_c = text;
    if (layer_name === "customer D") new_edit_slide_data.customer_d = text;

    if (layer_name === "feel A") new_edit_slide_data.feel_a = text;
    if (layer_name === "feel B") new_edit_slide_data.feel_b = text;

    if (layer_name === "business A") new_edit_slide_data.business_a = text;
    if (layer_name === "business B") new_edit_slide_data.business_b = text;
    if (layer_name === "business C") new_edit_slide_data.business_c = text;

    if (layer_name === "expert A") new_edit_slide_data.expert_a = text;
    if (layer_name === "expert B") new_edit_slide_data.expert_b = text;

    if (layer_name === "serve A") new_edit_slide_data.serve_a = text;
    if (layer_name === "serve B") new_edit_slide_data.serve_b = text;
    if (layer_name === "serve C") new_edit_slide_data.serve_c = text;
    if (layer_name === "serve D") new_edit_slide_data.serve_d = text;

    if (layer_name === "certified A") new_edit_slide_data.certified_a = text;
    if (layer_name === "certified B") new_edit_slide_data.certified_b = text;
    if (layer_name === "certified C") new_edit_slide_data.certified_c = text;

    if (layer_name === "experienced A")
      new_edit_slide_data.experienced_a = text;
    if (layer_name === "experienced B")
      new_edit_slide_data.experienced_b = text;

    if (layer_name === "guidance A") new_edit_slide_data.guidance_a = text;
    if (layer_name === "guidance B") new_edit_slide_data.guidance_b = text;
    if (layer_name === "guidance C") new_edit_slide_data.guidance_c = text;

    if (layer_name === "help A") new_edit_slide_data.help_a = text;
    if (layer_name === "help B") new_edit_slide_data.help_b = text;

    if (layer_name === "spot A") new_edit_slide_data.spot_a = text;
    if (layer_name === "spot B") new_edit_slide_data.spot_b = text;

    if (layer_name === "assessment A") new_edit_slide_data.assessment_a = text;
    if (layer_name === "assessment B") new_edit_slide_data.assessment_b = text;
    if (layer_name === "assessment C") new_edit_slide_data.assessment_c = text;

    if (layer_name === "window A") new_edit_slide_data.window_a = text;
    if (layer_name === "window B") new_edit_slide_data.window_b = text;
    if (layer_name === "window C") new_edit_slide_data.window_c = text;

    if (layer_name === "demand A") new_edit_slide_data.demand_a = text;
    if (layer_name === "demand B") new_edit_slide_data.demand_b = text;
    if (layer_name === "demand C") new_edit_slide_data.demand_c = text;
    if (layer_name === "demand D") new_edit_slide_data.demand_d = text;
    if (layer_name === "demand E") new_edit_slide_data.demand_e = text;
    if (layer_name === "demand F") new_edit_slide_data.demand_f = text;

    if (layer_name === "meet A") new_edit_slide_data.meet_a = text;
    if (layer_name === "meet B") new_edit_slide_data.meet_b = text;

    if (layer_name === "spring A") new_edit_slide_data.spring_a = text;
    if (layer_name === "spring B") new_edit_slide_data.spring_b = text;
    if (layer_name === "spring C") new_edit_slide_data.spring_c = text;
    if (layer_name === "spring D") new_edit_slide_data.spring_d = text;
    if (layer_name === "spring E") new_edit_slide_data.spring_e = text;
    if (layer_name === "spring F") new_edit_slide_data.spring_f = text;
    if (layer_name === "spring G") new_edit_slide_data.spring_g = text;
    if (layer_name === "spring H") new_edit_slide_data.spring_h = text;

    if (layer_name === "holiday A") new_edit_slide_data.holiday_a = text;
    if (layer_name === "holiday B") new_edit_slide_data.holiday_b = text;

    if (layer_name === "hassels A") new_edit_slide_data.hassels_a = text;
    if (layer_name === "hassels B") new_edit_slide_data.hassels_b = text;

    if (layer_name === "ladder A") new_edit_slide_data.ladder_a = text;
    if (layer_name === "ladder B") new_edit_slide_data.ladder_b = text;
    if (layer_name === "ladder C") new_edit_slide_data.ladder_c = text;

    if (layer_name === "reach A") new_edit_slide_data.reach_a = text;
    if (layer_name === "reach B") new_edit_slide_data.reach_b = text;
    if (layer_name === "reach C") new_edit_slide_data.reach_c = text;

    if (layer_name === "worry A") new_edit_slide_data.worry_a = text;
    if (layer_name === "worry B") new_edit_slide_data.worry_b = text;

    if (layer_name === "plumbing A") new_edit_slide_data.plumbing_a = text;
    if (layer_name === "plumbing B") new_edit_slide_data.plumbing_b = text;
    if (layer_name === "plumbing C") new_edit_slide_data.plumbing_c = text;
    if (layer_name === "plumbing D") new_edit_slide_data.plumbing_d = text;
    if (layer_name === "plumbing E") new_edit_slide_data.plumbing_e = text;
    if (layer_name === "plumbing F") new_edit_slide_data.plumbing_f = text;
    if (layer_name === "plumbing G") new_edit_slide_data.plumbing_g = text;

    if (layer_name === "quality A") new_edit_slide_data.quality_a = text;
    if (layer_name === "quality B") new_edit_slide_data.quality_b = text;
    if (layer_name === "quality C") new_edit_slide_data.quality_c = text;

    if (layer_name === "money A") new_edit_slide_data.money_a = text;
    if (layer_name === "money B") new_edit_slide_data.money_b = text;
    if (layer_name === "money C") new_edit_slide_data.money_c = text;
    if (layer_name === "money D") new_edit_slide_data.money_d = text;

    if (layer_name === "needs A") new_edit_slide_data.needs_a = text;
    if (layer_name === "needs B") new_edit_slide_data.needs_b = text;

    if (layer_name === "professional A")
      new_edit_slide_data.professional_a = text;
    if (layer_name === "professional B")
      new_edit_slide_data.professional_b = text;

    if (layer_name === "professional C")
      new_edit_slide_data.professional_c = text;

    if (layer_name === "moments A") new_edit_slide_data.moments_a = text;
    if (layer_name === "moments B") new_edit_slide_data.moments_b = text;
    if (layer_name === "moments C") new_edit_slide_data.moments_c = text;
    if (layer_name === "moments D") new_edit_slide_data.moments_d = text;
    if (layer_name === "moments E") new_edit_slide_data.moments_e = text;

    if (layer_name === "trained A") new_edit_slide_data.trained_a = text;
    if (layer_name === "trained B") new_edit_slide_data.trained_b = text;
    if (layer_name === "trained C") new_edit_slide_data.trained_c = text;
    if (layer_name === "trained D") new_edit_slide_data.trained_d = text;

    if (layer_name === "master A") new_edit_slide_data.master_a = text;
    if (layer_name === "master B") new_edit_slide_data.master_b = text;
    if (layer_name === "master C") new_edit_slide_data.master_c = text;
    if (layer_name === "master D") new_edit_slide_data.master_d = text;

    if (layer_name === "need A") new_edit_slide_data.need_a = text;
    if (layer_name === "need B") new_edit_slide_data.need_b = text;
    if (layer_name === "need C") new_edit_slide_data.need_c = text;

    if (layer_name === "work A") new_edit_slide_data.work_a = text;
    if (layer_name === "work B") new_edit_slide_data.work_b = text;
    if (layer_name === "work C") new_edit_slide_data.work_c = text;
    if (layer_name === "work D") new_edit_slide_data.work_d = text;
    if (layer_name === "work F") new_edit_slide_data.work_f = text;

    if (layer_name === "work E")
      new_edit_slide_data.work_e = text.replace("  ", "<br />");

    if (layer_name === "suffer A") new_edit_slide_data.suffer_a = text;
    if (layer_name === "suffer B") new_edit_slide_data.suffer_b = text;

    if (layer_name === "result A") new_edit_slide_data.result_a = text;
    if (layer_name === "result B") new_edit_slide_data.result_b = text;
    if (layer_name === "result C") new_edit_slide_data.result_c = text;

    if (layer_name === "qualified A") new_edit_slide_data.qualified_a = text;
    if (layer_name === "qualified B") new_edit_slide_data.qualified_b = text;
    if (layer_name === "qualified C") new_edit_slide_data.qualified_c = text;
    if (layer_name === "qualified D") new_edit_slide_data.qualified_d = text;

    if (layer_name === "improve A") new_edit_slide_data.improve_a = text;
    if (layer_name === "improve B") new_edit_slide_data.improve_b = text;

    if (layer_name === "consultation A")
      new_edit_slide_data.consultation_a = text;
    if (layer_name === "consultation B")
      new_edit_slide_data.consultation_b = text;

    if (layer_name === "floor A") new_edit_slide_data.floor_a = text;
    if (layer_name === "floor B") new_edit_slide_data.floor_b = text;
    if (layer_name === "floor C") new_edit_slide_data.floor_c = text;
    if (layer_name === "floor D") new_edit_slide_data.floor_d = text;
    if (layer_name === "floor E") new_edit_slide_data.floor_e = text;

    if (layer_name === "further A") new_edit_slide_data.further_a = text;
    if (layer_name === "further B") new_edit_slide_data.further_b = text;

    if (layer_name === "provide A") new_edit_slide_data.provide_a = text;
    if (layer_name === "provide B") new_edit_slide_data.provide_b = text;
    if (layer_name === "provide C") new_edit_slide_data.provide_c = text;

    if (layer_name === "everyday A") new_edit_slide_data.everyday_a = text;

    if (layer_name === "Engageleads A") new_edit_slide_data.engageleads_a = text;
    if (layer_name === "Engageleads B") new_edit_slide_data.engageleads_b = text;
    if (layer_name === "Engageleads C") new_edit_slide_data.engageleads_c = text;
    if (layer_name === "Engageleads D") new_edit_slide_data.engageleads_d = text;
    if (layer_name === "Engageleads E") new_edit_slide_data.engageleads_e = text;
    if (layer_name === "Engageleads F") new_edit_slide_data.engageleads_f = text;
    if (layer_name === "Engageleads G") new_edit_slide_data.engageleads_g = text;
    if (layer_name === "Engageleads H") new_edit_slide_data.engageleads_h = text;

    if (layer_name === "Author A") new_edit_slide_data.author_a = text;
    if (layer_name === "Author B") new_edit_slide_data.author_b = text;
    if (layer_name === "Author C") new_edit_slide_data.author_c = text;

    if (layer_name === "bg_author") new_edit_slide_data.bg_author = text; 
    if (layer_name === "Shape_layer") new_edit_slide_data.Shape_layer = text; 
    if (layer_name === "Shape_layer_1") new_edit_slide_data.Shape_layer_1 = text; 
    if (layer_name === "Shape_layer_2") new_edit_slide_data.Shape_layer_2 = text; 

    // dispatch(campaignAction.setSlideData({ data: new_edit_slide_data }));
    setDummySlideData(new_edit_slide_data);
  };

  const makeDefault = (e, layer_name, index) => {
    e.preventDefault();
    // console.log(editContent);

    // console.log(index);
    // return false;
    var single_layer = { ...editContent[index] };
    // console.log(single_layer);

    if (layer_name.includes("bg_color")) {
      single_layer.text = single_layer.default_text;
      setNewEditslideData(layer_name, single_layer.default_text);
    } else {
      single_layer.fontColor = single_layer.default_fontColor;
      single_layer.fontFamily = single_layer.default_fontFamily;
    }

    // console.log(single_layer);
    // return false;

    var newEditContent = [...editContent];
    newEditContent[index] = single_layer;

    setEdiContent(newEditContent);

    var copy_slide = { ...dummySingleslide };
    var assets = copy_slide.assets;
    var newData = assets.map((slide_data) => {
      var a = { ...slide_data };
      // console.log(a);
      if (a.layerName === layer_name) {
        a = { ...a, ...single_layer };
      }
      return a;
    });
    copy_slide.assets = newData;

    setDummySingleslide(copy_slide);
  };

  const applyCss = (fontFamily) => {
    let css = {};

    if (fontFamily.includes("Poppins")) {
      css.fontFamily = `'Poppins', sans-serif`;

      if (fontFamily === "Poppins-ExtraBold") {
        css.fontWeight = 800;
      } else if (fontFamily === "Poppins-ExtraLight") {
        css.fontWeight = 200;
      } else if (fontFamily === "Poppins-SemiBold") {
        css.fontWeight = 600;
      } else if (fontFamily === "Poppins-SemiBoldItalic") {
        css.fontWeight = 600;
        css.fontStyle = "italic";
      } else if (fontFamily === "Poppins-Bold") {
        css.fontWeight = 700;
      } else if (fontFamily === "Poppins-Medium") {
        css.fontWeight = 500;
      } else if (fontFamily === "Poppins-Thin") {
        css.fontWeight = 100;
      } else if (fontFamily === "Poppins-Italic") {
        css.fontStyle = "italic";
        css.fontWeight = 400;
      } else {
        css.fontWeight = 400;
      }
    } else if (fontFamily.includes("Roboto")) {
      css.fontFamily = `'Roboto', sans-serif`;
      if (fontFamily === "Roboto-Black") {
        css.fontWeight = 900;
      } else if (fontFamily === "Roboto-Bold") {
        css.fontWeight = 700;
      } else if (fontFamily === "Roboto-BoldItalic") {
        css.fontWeight = 700;
        css.fontStyle = "italic";
      } else if (fontFamily === "Roboto-Italic") {
        css.fontWeight = 400;
        css.fontStyle = "italic";
      } else {
        css.fontWeight = 500;
      }
    } else if (fontFamily.includes("Ubuntu")) {
      css.fontFamily = `'Ubuntu', sans-serif`;

      if (fontFamily === "Ubuntu-Bold") {
        css.fontWeight = 700;
      } else if (fontFamily === "Ubuntu-Medium") {
        css.fontWeight = 500;
      } else if (fontFamily === "Ubuntu-Italic") {
        css.fontWeight = 400;
        css.fontStyle = "italic";
      }
    } else if (fontFamily.includes("Montserrat")) {
      css.fontFamily = `'Montserrat', sans-serif`;

      if (fontFamily === "Montserrat-Italic") {
        css.fontWeight = 400;
        css.fontStyle = "italic";
      } else if (fontFamily === "Montserrat-Medium") {
        css.fontWeight = 500;
      } else if (fontFamily === "Montserrat-SemiBold") {
        css.fontWeight = 600;
      } else if (fontFamily === "Montserrat-SemiBoldItalic") {
        css.fontWeight = 600;
        css.fontStyle = "italic";
      } else if (fontFamily === "Montserrat-Thin") {
        css.fontWeight = 100;
      } else if (fontFamily === "Montserrat-BoldItalic") {
        css.fontWeight = 700;
        css.fontStyle = "italic";
      } else if (fontFamily === "Montserrat-Bold") {
        css.fontWeight = 700;
      } else if (fontFamily === "Montserrat-ExtraBold") {
        css.fontWeight = 800;
      } else {
        css.fontWeight = 400;
      }
    } else if (fontFamily === "Lobster") {
      css.fontFamily = `'Lobster', cursive`;
    } else if (fontFamily.includes("NexaBold")) {
      css.fontFamily = "NexaBold";

      // if (fontFamily === "Nexa-Bold") {
      //   css.fontWeight = 700;
      // } else if (fontFamily === "Nexa-light") {
      //   css.fontWeight = 300;
      // } else {
      //   css.fontWeight = 400;
      // }
    } else if (fontFamily.includes("Play Fair")) {
      css.fontFamily = `'Playfair Display', serif`;

      if (fontFamily === "Play Fair-ExtraBold") {
        css.fontWeight = 800;
      } else if (fontFamily === "Play Fair-SemiBold") {
        css.fontWeight = 600;
      } else if (fontFamily === "Play Fair-Medium") {
        css.fontWeight = 500;
      } else {
        css.fontWeight = 400;
      }
    } else if (fontFamily === "Amanda Signature") {
      css.fontFamily = "amandasignature";
    } else if (fontFamily === "Tw Cen MT") {
      css.fontFamily = "TCB";
    } else if (fontFamily === "Berkshire Swash") {
      css.fontFamily = `'Berkshire Swash', cursive`;
    } else if (fontFamily === "BebasNeueBold") {
      css.fontFamily = "BebasNeueBold";
    } else if (fontFamily === "BebasNeueBook") {
      css.fontFamily = "BebasNeueBook";
    } else if (fontFamily === "Tenor Sans") { 
      css.fontFamily = "Tenor Sans";
    } else if (fontFamily === "Gilroy-Medium") {
      css.fontFamily = "GilroyMedium";
    } else if (fontFamily === "Gilroy-Bold") {
      css.fontFamily = "GilroyBold";
    } else if (fontFamily === "Gilroy-ExtraBold") {
      css.fontFamily = "GilroyExtraBold";
    } else if (fontFamily === "DIN Condensed"){
      css.fontFamily = "DINCondensedBold";
    }
    // console.log(css);
    return css;
  };

  const formatOptionLabel = ({ value, label }) => (
    <span style={applyCss(value)}>{label}</span>
  );

  return (
    <>
      {show && (
        <div className={`popup_hv ${popup_hv_class}`}>
          <ReactTooltip />
          <div
            className="backdropDiv"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              width: "100%",
              height: "100%",
            }}
            onClick={() => {
              toggleLeftContentshow();
            }}
          ></div>
          <div className="popup_form">
            <form onSubmit={handleSubmit}>
              {/* <h5 className="pb-3">
                <small>
                  <strong className="text-danger">Note : </strong> Edior section
                  not represent final video view
                </small>
              </h5> */}
              <h4 className="pb-2">Control Configuration</h4>

              {editContent.length > 0 &&
                editContent.map((single_layer, index) => {
                  return (
                    <div key={`key-${index}`}>
                      {single_layer.layerName.includes("bg_color") ? (
                        <div className="col-md-12">
                          <div className="form-group position-relative">
                            <label className="pb-3">
                              Background / Border Color :
                              <span
                                className="pull-right makeDefault"
                                onClick={(e) =>
                                  makeDefault(e, single_layer.layerName, index)
                                }
                              >
                                <BiRefresh size={20} /> <u>Set Default</u>{" "}
                                <a
                                  href="0#"
                                  rel="noreferrer"
                                  data-effect="solid"
                                  data-tip="Set default value of color"
                                >
                                  <BsInfoSquareFill className="text-dark" />
                                </a>
                              </span>
                            </label>
                            <ColorPicker
                              layers_name={single_layer.layerName}
                              font_color={single_layer.text}
                              index={index}
                              handleColor={handleHRXColor}
                            />
                          </div>
                        </div>
                      ) : (single_layer.layerName.includes("bg_author") || single_layer.layerName.includes("Shape_layer_1") || single_layer.layerName.includes("Shape_layer_2") || single_layer.layerName.includes("Shape_layer") ||  single_layer.layerName.includes("icon_image")) ? (
                        <div className="col-md-12">
                          <div className="form-group position-relative">
                            <label className="pb-3">
                              Background/Icon/Border :
                              <span
                                className="pull-right makeDefault"
                                onClick={(e) =>
                                  makeDefault(e, single_layer.layerName, index)
                                }
                              >
                                <BiRefresh size={20} /> <u>Set Default</u>{" "}
                                <a
                                  href="0#"
                                  rel="noreferrer"
                                  data-effect="solid"
                                  data-tip="Set default value of color"
                                >
                                  <BsInfoSquareFill className="text-dark" />
                                </a>
                              </span>
                            </label>
                            <ColorPicker
                              layers_name={single_layer.layerName}
                              font_color={single_layer.text}
                              index={index}
                              handleColor={handleHRXColor}
                            />
                          </div>
                        </div>
                      ): (
                        <>
                          <div className="col-md-12">
                            <div
                              className="form-group position-relative"
                              key={index}
                            >
                              <label className="pb-3">
                                Element {index + 1}{" "}
                                <span
                                  className="pull-right makeDefault"
                                  onClick={(e) =>
                                    makeDefault(
                                      e,
                                      single_layer.layerName,
                                      index
                                    )
                                  }
                                >
                                  <BiRefresh size={20} /> <u>Set Default</u>{" "}
                                  <a
                                    href="0#"
                                    rel="noreferrer"
                                    data-effect="solid"
                                    data-tip="Set default value of font family and color"
                                  >
                                    <BsInfoSquareFill className="text-dark" />
                                  </a>
                                </span>
                              </label>
                              <span className="mlnk_txt position-absolute mt-1">
                                <span
                                  className={`${
                                    single_layer.text.length >=
                                      parseInt(textLength[index]) &&
                                    "text-danger fw-bold"
                                  }`}
                                >
                                  {single_layer.text.length}
                                </span>
                                /{textLength[index]}
                              </span>
                              <input
                                type="text"
                                className={`form-control ${
                                  single_layer.text.length >=
                                    parseInt(textLength[index]) && "max-length"
                                }`}
                                maxLength={parseInt(textLength[index])+30}
                                value={single_layer.text}
                                onChange={(e) => {
                                  handleChnage(
                                    e,
                                    single_layer.layerName,
                                    index
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="row">
                            {/* <div className="col-sm-4">
                              <label className="">
                                Element {index + 1} Font Size
                              </label>

                              <input
                                type="number"
                                className={`form-control `}
                                value={single_layer.fontSize}
                                onChange={(e) => {
                                  handleChnageFont(
                                    e,
                                    single_layer.layerName,
                                    index
                                  );
                                }}
                              />
                            </div> */}
                            <div className="col-sm-6">
                              <label className="">Font Color</label>

                              <ColorPicker
                                layers_name={single_layer.layerName}
                                font_color={single_layer.fontColor}
                                index={index}
                                handleColor={handleColor}
                              />
                            </div>
                            <div className="col-sm-6">
                              <label>Font Family</label>
                              <Select
                                options={options}
                                value={options.filter(
                                  (option) =>
                                    option.value === single_layer.fontFamily
                                )}
                                className=""
                                formatOptionLabel={formatOptionLabel}
                                onChange={(e) => {
                                  handleChangeFontFamily(
                                    e,
                                    single_layer.layerName,
                                    index
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}

              <input
                name="submit"
                type="submit"
                value="Save"
                className="btn w-100 mt-2"
              />
            </form>

            <button
              type="button"
              className="close_btn"
              onClick={() => {
                toggleLeftContentshow();
              }}
            >
              <i className="fa fa-close"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LeftContentEditor;
